@if (feature().type === customerFeatureTypeEnum.LISTA_DIG_VARDEN &&
isCustomer()) {
  <app-ui-button
    [color]="color()"
    [eventAction]="eventActionEnum.LISTA_DIG_VARDEN_DIRECT"
    [eventCategory]="eventCategoryEnum.LISTA_DIG_DIRECT"
    [eventLabel]="label()"
    [eventParams]="{
      callToAction: listaDigSimpleLinkCallToAction,
      cpruId: feature().caregiverUnitId,
      pageType: pageType()
    }"
    [linkTarget]="'_blank'"
    [linkTitle]="feature().label"
    [linkUrl]="feature().url"
    [ngClass]="btnClass()"
    [size]="size()"
    appGtmEvent
    appGtmGa4Event
    expanded="block"
  >
    {{ feature().label }}
  </app-ui-button>
}


@if (feature().type === customerFeatureTypeEnum.APP_STORE_BTN) {
  <a
    [eventAction]="eventActionEnum.APPSTORE"
    [eventCategory]="eventCategoryEnum.APP"
    [eventLabel]="'organizationId:' + feature().caregiverUnitId"
    [eventParams]="{
      callToAction: eventCategoryEnum.APP + ' - ' + eventActionEnum.APPSTORE,
      cpruId: feature().caregiverUnitId,
      pageType: pageType()
    }"
    [href]="feature().url"
    [ngClass]="btnClass()"
    appGtmEvent
    appGtmGa4Event
  >
    <img
      [ngSrc]="appStoreImgUrl()"
      alt="App Store"
      height="48"
      width="144"
    >
  </a>
}


@if (feature().type === customerFeatureTypeEnum.GOOGLE_PLAY_BTN) {
  <a
    [eventAction]="eventActionEnum.GOOGLEPLAY"
    [eventCategory]="eventCategoryEnum.APP"
    [eventLabel]="'organizationId:' + feature().caregiverUnitId"
    [eventParams]="{
      callToAction: eventCategoryEnum.APP + ' - ' + eventActionEnum.GOOGLEPLAY,
      cpruId: feature().caregiverUnitId,
      pageType: pageType()
    }"
    [href]="feature().url"
    [ngClass]="btnClass()"
    appGtmEvent
    appGtmGa4Event
  >
    <img
      [ngSrc]="googlePlayImgUrl()"
      alt="Google Play"
      height="48"
      width="164"
    >
  </a>
}

